export default "/images/ic-credits.svg?627fcf1ff51f100bdd7be1cce70ed038";